import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import { WpButton } from 'Wpds/components/button';
import { WpFormLayout } from 'Wpds/components/form';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpCollapsible } from 'Wpds/components/collapsible';

// Styles
import './GPT3Example.scss';

type Props = {
  value: string;
  setValue;
  inputId: string;
  label: string;
  placeholder: string;
};

const GPT3Example = ({ label, inputId, value, setValue, placeholder }: Props) => {
  const { featureFlagFeedbackaiExamples } = useFlags();
  const [open, toggleOpen] = useToggle(false);

  const baseClassName = 'GPT3Example';

  if (!featureFlagFeedbackaiExamples) return null;

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__button`}>
        <WpButton variant="tertiary" onClick={toggleOpen}>
          Examples (Optional)
        </WpButton>
      </div>

      <WpCollapsible open={open} animationDuration={300}>
        <WpFormLayout direction="horizontal">
          <WpTextField
            id={inputId}
            label={label}
            value={value}
            onChange={setValue}
            labelHidden
            max={600}
            multiline={3}
            placeholder={placeholder}
            autoFocus
          />
        </WpFormLayout>
      </WpCollapsible>
    </div>
  );
};

export default GPT3Example;
